import { PlantBiodiversity } from "../../../../../api/types/plants";
import { CafsVariable } from "../../../../../types/cafs-variable";
import { CafsVariableType } from "../../../const/cafs-variable-type";

export function useBiodiversityVariables(): CafsVariable<PlantBiodiversity>[] {
  return [
    {
      name: "BiodiversityRemarks",
      type: CafsVariableType.Remarks,
    },
    {
      name: "ShannonBiodiverstitySpeciesEquivalent",
      type: CafsVariableType.Input,
    },
    {
      name: "IsIndigenous",
      type: CafsVariableType.Boolean,
    },
  ];
}
